export { Alert as AlertQldDS } from './alert/Alert';
export { AddressField as AddressFieldQldDS } from './addressField/AddressField';
export { Button as ButtonQHDS } from './button/Button';
export { AriaButton as AriaButtonQHDS } from './button/AriaButton';
export { CheckboxField as CheckboxFieldQldDS } from './checkboxField/CheckboxField';
export { CheckboxGroupField as CheckboxGroupFieldQldDS } from './checkboxGroupField/CheckboxGroupField';
export { DateField as DateFieldQldDS } from './dateField/DateField';
export { FileUploadField as FileUploadFieldQldDS } from './fileUploadField/FileUploadField';
export { Label as LabelQldDS } from './label/Label';
export { LoadingSpinner as LoadingSpinnerQldDS } from './spinner/LoadingSpinner';
export { RadioGroupField as RadioGroupFieldQldDS } from './radioGroupField/RadioGroupField';
export { SearchField as SearchFieldQldDS } from './searchField/SearchField';
export { SelectField as SelectFieldQldDS } from './selectField/SelectField';
export { TextField as TextFieldQldDS } from './textField/TextField';
export { TimeField as TimeFieldQldDS } from './timeField/TimeField';
export { H1, H2, H3, H4, H5, H6, Text, Link, Caption } from './typography/Typography';

export type FieldWidth = FieldFluidWidth | FieldFixedWidth;

// Fluid widths
type FieldFluidWidth = 'small' | 'medium' | 'large' | 'full';

// Fixed widths for fields of 2, 3, 4, 5, 10 or 20 characters
type FieldFixedWidth =
	| 'fixedWidth1'
	| 'fixedWidth2'
	| 'fixedWidth3'
	| 'fixedWidth4'
	| 'fixedWidth5'
	| 'fixedWidth6';
